var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trawl-modal-confirm',{attrs:{"ok":_vm.cancel}},[_c('template',{slot:"trigger"},[_c('a-button',{attrs:{"type":"danger","ghost":""}},[_vm._v("Request")])],1),_vm._v(" "),_c('template',{slot:"text"},[_c('p',[_vm._v("\n      Apakah kamu ingin menolak pencairan dana?\n    ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }